<script lang="ts" setup>
defineOptions({ name: 'ContentCollapse' });
defineProps<{
  title: string;
}>();
defineSlots<{
  default: () => VNode[];
}>();

const isExpanded = ref(false);
</script>

<template>
  <BaseExpandedBlock :title="title" v-model:expanded="isExpanded" content-tag="div" class="contentCollapse">
    <slot />
  </BaseExpandedBlock>
</template>

<style lang="scss">
.contentCollapse p {
  margin-bottom: 0 !important;
}
</style>
